import Vue from "vue";

import "core-js/stable";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "./axios/index";

import "./icons";
import SvgIcon from "./components/SvgIcon.vue";

//定义全局删除case方法，提供给java调用
window.cancelCase = () => {
  //alert("cancelcase")
  //未确认case关闭时调用
  if (router.history.current.path == "/repairNew") {
    //以防退出新建
    if (router.history.current.query.caseId) {
      //alert("调用cancelcase")
      axios({
        url:
          process.env.VUE_APP_API +
          "addCaseForOA?" +
          "caseId=" +
          router.history.current.query.caseId +
          "&delete=T",
        method: "post",
      })
        .then(() => {
          //  alert("删除成功")
        })
        .catch(() => {});
    }
  }
};

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.prototype.$axios = axios;

Vue.component("svg-icon", SvgIcon);

Vue.prototype.$mediaSize = window.SIZE;

new Vue({
  router,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount("#app");
